export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4853.c58f7bc6.jpg";